// src/redux/branding/actions.ts
import { createAsyncThunk } from '@reduxjs/toolkit';
import { type, BrandingState } from './state';
import { shopPublicService } from '../../services';

export const fetchSiteConfigAction = createAsyncThunk(
    `${type}/fetchSiteConfig`,
    async (_arg: void, { rejectWithValue }) => {
        try {
            return await shopPublicService.getSiteConfig();
        } catch (error) {
            return rejectWithValue(error);
        }
    },
    {
        // Fetch-once guard: a storefront screen mounts several branding
        // consumers, and every screen navigation mounts more — without this,
        // each fires its own GET /public/site-config and thrashes `loaded`
        // (F21). Skip while a request is in flight, and once we already hold a
        // good config; still allow a retry after an error.
        condition: (_arg, { getState }) => {
            const { branding } = getState() as { branding: BrandingState };
            if (branding.isFetching) return false;
            if (branding.loaded && !branding.error) return false;
            return true;
        },
    }
);
